<template>
  <div class="container">
    <section>
      <img class="title" src="../assets/high-school-course-title.svg" />
      <dl>
        <dt>黃浩數學</dt>
        <dd>
          政大應數系，<br />
          數學科排推手！
        </dd>
        <dt>青易數學</dt>
        <dd>
          台大數學所榜首教師！
        </dd>
        <dt>承恩物理</dt>
        <dd>
          滿級分領航者，<br />
          多次帶隊出國參賽！
        </dd>
        <dt>郭志雄物理</dt>
        <dd>
          資深補教名師，<br />
          教出一堆台大高材生！
        </dd>
        <dt>李立化學</dt>
        <dd>二十年教學經驗！</dd>
        <dt>陸謙生物</dt>
        <dd>色彩式筆記，活潑生動！</dd>
      </dl>

      <p>
        還在跑超大班高中補習嗎<br />
        在擠滿百人的教室裡，老師教的聽不懂、下課後卻沒人問？<br /><br />
        還不曉得高僑高中部有精緻的小班教學！？<br />
        強大的教師群帶領你前往15級分！<br />
        小考檢測學習成果、細心輔導解決問題
      </p>

      <ul>
        <li>
          數學、物理、化學、生物從高一連續教學，適合衛道、曉明、明道超前進度，及一中、女中、興大附中、文華、二中，學生參加。
        </li>
        <li>
          每堂下課後，老師親自輔導，回答到學生沒問題才離開，平時還有優秀學長姊輔導。
        </li>
        <li>
          老師多年教學經驗，擅長解決學生的困難、找到痛點，帶你衝向15級分！
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.container {
  background: url("../assets/high-school-course-bg-left.svg") left top no-repeat,
    url("../assets/high-school-course-bg-right.svg") right 162px no-repeat;

  section {
    max-width: 500px;
    margin: auto;
    text-align: center;

    .title {
      display: block;
      margin: 60px auto;
      width: 135px;
    }

    dt {
      font-size: 20px;
      font-weight: bold;
      color: #1c2e53;
    }

    dd {
      margin-left: 0;
      margin-bottom: 40px;
      font-size: 18px;
      font-weight: bold;
      color: #5d5d5d;
    }

    p {
      font-size: 16px;
      font-weight: bold;
      color: #3b3b3b;
      letter-spacing: 1.4px;
      line-height: 1.3rem;
      margin-bottom: 60px;
    }

    ul {
      li {
        text-align: left;
        list-style: none;
        color: #3b3b3b;
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 4px;

        &:before {
          content: "\2713";
          color: #e06960;
          font-weight: bold;
          font-size: 16px;
          display: inline-block;
          width: calc(1rem - 4px);
          margin-left: -1rem;
        }
      }
    }
  }
}
</style>
